$(document).ready(function () {
    let ajaxPath = '/includes/kunde/ajax.php';
    const ajaxPathGetRestaurantTablesFromStore = '/action/customer/production-order/get-restaurant-tables-from-store';
    const ajaxPathGetLoginLink = '/action/customer/production-order/get-login-link-and-qr';
    let contentWrapper = $('div#production_order_tab_wrapper');
    let ajaxLocked = false;

    let modalParentElementInDOM = $('div#content');
    let modalTitle = '';
    let modalMessage = '';
    let modalButtonText = 'Lukk';
    let modalAlertType = '';

    // Click on tab, check if a customer id is set
    $('#production_order_tab_link').click(function () {

        // Check that a customer is selected
        if (!$('input[name="kunde_id"]').length ||
            $('input[name="kunde_id"]').val() * 1 <= 0) {
            displayNoCustomerSelectedErrorMessage();
            return;
        }

        //Fetch form with prefilled data for selected ContactPerson
        $.post(
            ajaxPath,
            {
                action: 'get_production_order_info',
                customer_id: $('input[name="kunde_id"]').val()
            }, function (response) {
                if (response.status.toUpperCase() === 'OK') {
                    //Success, replace form
                    contentWrapper.html(response.html);
                } else {
                    //Error, show error message
                    displayAlertMessage('Kunne ikke hente info fra "fline QR-kode"!', response.error_message, 'danger', false);
                }
            }, 'json');
    });

    $(document).on('change', 'div#production_order_tab_wrapper select#select_store', function() {
        let syncCode = $('div#production_order_tab_wrapper select#select_store').find(":selected").val();

        if (syncCode > -2) {
            getRestaurantTableDropDown(syncCode);
        }
    });

    $(document).on('click', 'div#production_order_tab_wrapper button#generate_link_and_qr_code', function() {
        let customerId = $('form#kunde_form input#customer_id').val();
        let syncCode = $('div#production_order_tab_wrapper select#select_store').find(":selected").val();
        let restaurantTableId = $('div#production_order_tab_wrapper select#select_restaurant_table').find(":selected").val();
        createLinkAndQRCode(customerId, syncCode, restaurantTableId);
    });

    $(document).on('click', 'div#production_order_tab_wrapper button#copy_token', function() {
        let inputLoginLink = $(this).closest('div.fline-login-link-row').find('input.fline-login-links');
        copyLinksToClipBoard(inputLoginLink, $(this));
    });

    $(document).on('click', 'div#production_order_tab_wrapper button#print_qr', function() {
        let panelBody = $(this).closest('div.fline-login-link-card');
        openPrintQRCode(panelBody);
    });

    /**
     * Print error message that says no customer is selected
     */
    function displayNoCustomerSelectedErrorMessage() {
        contentWrapper.empty();
        window.displayAlertMessage('Du m&aring; lagre en ny kunde eller velge en eksisterende kunde f&oslash;rst', '', 'danger', contentWrapper);
    }

    /*
     * Display html message
     *
     *
     * @param String headerText
     * @param String message
     * @param String type
     */
    function displayAlertMessage(headerText, message, type) {
        window.displayAlertMessage(headerText, message, type, contentWrapper, true);
        return;
    }

    function getRestaurantTableDropDown(syncCode) {
        if (ajaxLocked) {
            return;
        }

        ajaxLocked = true;

        $.ajax({
            type: 'GET',
            url: ajaxPathGetRestaurantTablesFromStore,
            data: {
                sync_code: syncCode,
            },
            dataType: 'json'
        }).success(function (data) {
            $('div#select_restaurant_table_wrapper').replaceWith(data.html);

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);

        }).always(function () {
            ajaxLocked = false;
        });
    }

    function createLinkAndQRCode(customerId, storeSyncCode, restaurantTableId) {
        if (ajaxLocked) {
            return;
        }

        ajaxLocked = true;

        $.ajax({
            type: 'GET',
            url: ajaxPathGetLoginLink,
            data: {
                customer_id: customerId,
                store_sync_code: storeSyncCode,
                restaurant_table_id: restaurantTableId
            },
            dataType: 'json'
        }).success(function (data) {
            let loginLinksV1 = $('div#production_order_tab_wrapper div#login_links_version_1');
            let loginLinksV2 = $('div#production_order_tab_wrapper div#login_links_version_2');

            if (loginLinksV1.length) {
                loginLinksV1.replaceWith(data.html);
            } else if (loginLinksV2.length) {
                loginLinksV2.replaceWith(data.html);
            } else {
                $('div#production_order_tab_wrapper').append(data.html);
            }

        }).error(function (data) {
            modalTitle = 'Det oppstod en feil';
            modalMessage = $.parseJSON(data.responseText).errors;
            modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);

        }).always(function () {
            ajaxLocked = false;
        });
    }

    function copyLinksToClipBoard(inputLoginLinks, buttonClicked) {
        inputLoginLinks.focus();
        inputLoginLinks.select();

        try {
            let successful = document.execCommand('copy');
            buttonClicked.notify('Lenken ble kopiert', {position:"top", className: "success"});
            let msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
        } catch (err) {
            console.log('Oops, unable to copy');
        }
    }

    function openPrintQRCode(panelBody) {
        let qrCodeSrc = panelBody.find('img.qr_code_img').attr('src');
        let subdomain = panelBody.find('input.subdomain-link').val();
        let frontlineStoreElement = panelBody.find('div.frontline-store-name');
        let restaurantTableElement = panelBody.find('div.restaurant-table-name');
        let frontlineStoreName = '';
        let restaurantTableName = '';

        if (frontlineStoreElement.length) {
            frontlineStoreName = frontlineStoreElement.text();
        }
        if (restaurantTableElement.length) {
            restaurantTableName = restaurantTableElement.text();
        }

        let qrCodeHtml =  '<div style="text-align: center">' +
            '<b style="font-size: 26px">' + subdomain + '</b><br/><b style="font-size: 20px">' + frontlineStoreName +'<br/>' + restaurantTableName + '</b>' +
            '<br/><br/><img src="' + qrCodeSrc + '" alt="qr-code"</div>';

        openPrintWindow(qrCodeHtml);
    }

    function openPrintWindow(qrCodeHtml) {
        let newWindow = window.open();
        $(newWindow.document.body).html(qrCodeHtml);
        newWindow.print();
    }
});
